import { logger } from '@/lib/logger';

import { getUncaughtErrorEntries } from './errorCapture';
import { type LogTimelineEntry, serializeLoggerEntries } from './logTimeline';

/**
 * Defensive cap: the server rejects payloads > 1 MiB
 * (apps/diagnostics/views/__init__.py). Keeps the most-recent entries so a
 * staff user hitting repeated errors doesn't blow that limit and lose the
 * whole report.
 */
const MAX_TIMELINE_ENTRIES = 200;

export function buildLogTimeline(): LogTimelineEntry[] {
  const merged = [
    ...serializeLoggerEntries(logger.dump()),
    ...getUncaughtErrorEntries(),
  ];

  // Lexicographic sort is correct only because every `at` is produced by
  // new Date().toISOString() / entry.timestamp (same ISO 8601 format).
  merged.sort((a, b) => {
    if (a.at < b.at) {
      return -1;
    }
    return a.at > b.at ? 1 : 0;
  });

  return merged.slice(-MAX_TIMELINE_ENTRIES);
}
